export interface COCLASS {
  coclass: string
  description: string
  roomGroup: string
}

export interface COCLASSGROUP {
  [roomGroup: string]: { sv: string; en: string }
}

export const COCLASSGROUPS: Record<string, { sv: string; en: string }> = {
  'Gemensamma utrymmen': {
    sv: 'Gemensamma utrymmen',
    en: 'Common areas'
  },
  Laboratorier: {
    sv: 'Laboratorier',
    en: 'Laboratories'
  },
  Övrigt: {
    sv: 'Övrigt',
    en: 'Other'
  },
  Kontor: {
    sv: 'Kontor',
    en: 'Offices'
  },
  Mötesrum: {
    sv: 'Mötesrum',
    en: 'Meeting rooms'
  },
  Studierum: {
    sv: 'Studierum',
    en: 'Study rooms'
  },
  Lärosalar: {
    sv: 'Lärosalar',
    en: 'Lecture halls'
  },
  Hörsalar: {
    sv: 'Hörsalar',
    en: 'Auditoriums'
  },
  Datorsalar: {
    sv: 'Datorsalar',
    en: 'Computer labs'
  },
  Arbetsplats: {
    sv: 'Arbetsplats',
    en: 'Workplace'
  },
  Kontorslandskap: {
    sv: 'Kontorslandskap',
    en: 'Open plan office'
  }
}

export const COCLASSES: COCLASS[] = [
  {
    coclass: 'UTBD',
    description: 'Utrymme för idrott och kultur',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCCD',
    description: 'Akvarium',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDBD',
    description: 'Analysutrustningsrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAD',
    description: 'Apparatutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTABA',
    description: 'Badrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTAAE',
    description: 'Balkong',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTABF',
    description: 'Bastu',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAH',
    description: 'Behandlingsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCCA',
    description: 'Bur',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCEA',
    description: 'Bårhus',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCCB',
    description: 'Bås',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCC',
    description: 'Djurhållningsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTABE',
    description: 'Duschrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAA',
    description: 'El-utrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEAA',
    description: 'Entré',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTCBD',
    description: 'Fordonsförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAD',
    description: 'Försäljningslokal',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBC',
    description: 'Försöksutrymme',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTCE',
    description: 'Förvaring av avlidna',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTC',
    description: 'Förvaringsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBHA',
    description: 'Godshanteringsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEAE',
    description: 'Hisschakt',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTAB',
    description: 'Hygienutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBDA',
    description: 'Idrottsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAD',
    description: 'Informationsarkiv',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEAG',
    description: 'Inspektionsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCBA',
    description: 'Inventarieförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAB',
    description: 'IT-utrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEBC',
    description: 'Kanal',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAB',
    description: 'Kemikalieförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBBD',
    description: 'Konstverkstad',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTBAA',
    description: 'Kontorsutrymme',
    roomGroup: 'Kontor'
  },
  {
    coclass: 'UTDBA',
    description: 'Kontrollrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEAC',
    description: 'Korridor',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTBBA',
    description: 'Kök',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAG',
    description: 'Livsmedelsförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEAB',
    description: 'Slussutrymme',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTDAC',
    description: 'Maskinrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCA',
    description: 'Materialförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBBB',
    description: 'Materialverkstad',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTBEA',
    description: 'Matsal',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAM',
    description: 'Medieverkstad',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAB',
    description: 'Mötesrum',
    roomGroup: 'Mötesrum'
  },
  {
    coclass: 'UTBDE',
    description: 'Nöjesutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTABD',
    description: 'Omklädningsrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBBE',
    description: 'Packrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAJ',
    description: 'Paketförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEAF',
    description: 'Passage',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTDBB',
    description: 'Produktionsrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAC',
    description: 'Reception',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTCBB',
    description: 'Redskapsförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAG',
    description: 'Rengöringsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBBC',
    description: 'Maskinverkstad',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTAAA',
    description: 'Rum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBEB',
    description: 'Samlingssal',
    roomGroup: 'Hörsalar'
  },
  {
    coclass: 'UTEBB',
    description: 'Schakt',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDBC',
    description: 'Servicerum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTACA',
    description: 'Skyddsrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTABC',
    description: 'Skötrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAM',
    description: 'Sprängmedelsförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAF',
    description: 'Studierum',
    roomGroup: 'Studierum'
  },
  {
    coclass: 'UTCAK',
    description: 'Textilförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBB',
    description: 'Tillverkningsutrymme',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTABB',
    description: 'Toalett',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEAD',
    description: 'Trappschakt',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTBDB',
    description: 'Träningsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAJ',
    description: 'Undersökningsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAE',
    description: 'Undervisningslokal',
    roomGroup: 'Lärosalar'
  },
  {
    coclass: 'UTAA',
    description: 'Uppehållsutrymme',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTAAD',
    description: 'Uteplats',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTCB',
    description: 'Utrustningsförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAC',
    description: 'Utrustningsrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBEC',
    description: 'Utställningsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCBE',
    description: 'Vapenförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTAAC',
    description: 'Väntutrymme',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTCAH',
    description: 'Värdeförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAE',
    description: 'Gas- och vätskeförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAA',
    description: 'Återvinningsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAK',
    description: 'Övervakningsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBDC',
    description: 'Övningsutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBZA',
    description: 'Utrymme för flera ändamål',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBGA',
    description: 'Växthusutrymme',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTANE',
    description: 'Åskådarläktare',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBED',
    description: 'Ceremoniellt utrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBHB',
    description: 'Lastkaj',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTJKB',
    description: 'Utrymningsväg',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTZZZ',
    description: 'Odefinierat utrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTAAA10',
    description: 'Sovrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTAAA20',
    description: 'Vilrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTAAB10',
    description: 'Vardagsrum',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTAAB30',
    description: 'Personalutrymme',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTBAA20',
    description: 'Kontorslandskap',
    roomGroup: 'Kontorslandskap'
  },
  {
    coclass: 'UTBAE21',
    description: 'Datasal',
    roomGroup: 'Datorsalar'
  },
  {
    coclass: 'UTABB10',
    description: 'RWC',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTABB11',
    description: 'RWC med skötbord',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTABB12',
    description: 'RWC med dusch',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBBA50',
    description: 'Pentry',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAG10',
    description: 'Tvättutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAG50',
    description: 'Tvätthall',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAK10',
    description: 'Kapprum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAK20',
    description: 'Klädkammare',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCBB10',
    description: 'Städförråd',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBH',
    description: 'Utrymme för varuhantering',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEBA10',
    description: 'Kulvert',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEBC10',
    description: 'Ventilationskanal',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAA10',
    description: 'Ställverksrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAB10',
    description: 'Serverrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAC10',
    description: 'Hissmaskinutrymme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAD10',
    description: 'Fläktrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAD40',
    description: 'Undercentral värme',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAD50',
    description: 'Sprinklercentral',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEAA20',
    description: 'Innerentré',
    roomGroup: 'Gemensamma utrymmen'
  },
  {
    coclass: 'UTBAB20',
    description: 'Telefonrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTBAB10',
    description: 'Grupprum',
    roomGroup: 'Studierum'
  },
  {
    coclass: 'UTBAE10',
    description: 'Föreläsningssal',
    roomGroup: 'Hörsalar'
  },
  {
    coclass: 'UTBAE20',
    description: 'Klassrum',
    roomGroup: 'Lärosalar'
  },
  {
    coclass: 'UTBAE26',
    description: 'Undervisningslaboratorium',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTBCA12',
    description: 'Kylt tekniklaboratorium',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTBCB12',
    description: 'Kylt materiallaboratorium',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTBCC12',
    description: 'Kylt biologilaboratorium',
    roomGroup: 'Laboratorier'
  },
  {
    coclass: 'UTCAD10',
    description: 'Bibliotek',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAD20',
    description: 'Arkiv',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAG10',
    description: 'Kylrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTCAG20',
    description: 'Frysrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAA40',
    description: 'Batterirum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAA50',
    description: 'Generatorrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTDAD60',
    description: 'Vattenbehandlingsrum',
    roomGroup: 'Övrigt'
  },
  {
    coclass: 'UTEBC11',
    description: 'Ventilationskammare',
    roomGroup: 'Övrigt'
  }
]

export const COCLASSES_AH = COCLASSES.filter((coclass) => coclass.coclass.startsWith('UT'))
